import React from "react";

//Section heading with the gold swirl underneath, as on Wix
const SectionTitle = ({ id, children, subtitle, as: Tag = "h2", className = "" }) => (
  <div className={`section-heading ${className}`}>
    <Tag
      id={id}
      className={"section-title"}
    >
      {children}
    </Tag>
    {subtitle ? <p className={"section-subtitle"}>{subtitle}</p> : null}
    <img
      src={"/images/divider.png"}
      alt={""}
      width={106}
      height={31}
      className={"section-divider"}
    />
  </div>
);

export default SectionTitle;
